import React, { useRef } from 'react';
import { Dialog, DialogContent, DialogTitle, DialogDescription } from '../ui/dialog';

export const VideoModal = ({ open, onOpenChange }) => {
  const videoRef = useRef(null);

  const handleOpenChange = (next) => {
    if (!next && videoRef.current) {
      videoRef.current.pause();
      videoRef.current.currentTime = 0;
    }
    onOpenChange(next);
  };

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent
        className="max-w-[420px] border-none bg-transparent p-0 shadow-none"
        data-testid="video-modal"
      >
        <DialogTitle className="sr-only">UNWP — the story in 50 seconds</DialogTitle>
        <DialogDescription className="sr-only">
          Our 50-second social film showing how a UNWP surprise reveal unfolds.
        </DialogDescription>
        <div className="relative overflow-hidden rounded-3xl bg-black shadow-2xl ring-1 ring-white/10">
          <video
            ref={videoRef}
            poster="/unwp-ad-poster.jpg"
            controls
            autoPlay
            muted
            playsInline
            className="h-auto max-h-[80vh] w-full"
            data-testid="video-modal-player"
          >
            <source src="/unwp-ad.mp4" type='video/mp4; codecs="avc1.64001F, mp4a.40.2"' />
            <source src="/unwp-ad.mp4" type="video/mp4" />
          </video>
        </div>
      </DialogContent>
    </Dialog>
  );
};
